import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Map } from "immutable";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import {
  Authorized,
  ClipboardCopy,
  Forbidden
} from "MODULES/shared/components";
import {
  ACCOUNTING,
  QUALITY_CONTROL,
  WAREHOUSE
} from "MODULES/users/constants";
import {
  API_BASE,
  CANCELLED,
  CODE,
  COST,
  CREATED_AT,
  ID,
  RECEIVED
} from "APP_ROOT/constants";
import RecordPager from "MODULES/shared/components/RecordPager/RecordPager";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { LOT } from "MODULES/Lots/constants";
import { CANCELLATION_REASONS } from "MODULES/Orders/shared/constants";
import CancelLot from "MODULES/Lots/Detail/CancelLot/CancelLot";
import MarkLotReceived from "MODULES/Lots/Detail/MarkLotReceived/MarkLotReceived";
import { Warning } from "MODULES/PurchaseOrders/components/Detail/Warnings";
import { APPROVED, CAN_APPROVE } from "MODULES/companies/constants";
import ApproveLot from "MODULES/Lots/Detail/ApproveLot/ApproveLot";
import ImportLineItems from "MODULES/Lots/Detail/ImportLineItems/ImportLineItems";
import DownloadLot from "MODULES/Lots/Detail/DownloadLot/DownloadLot";
import SetTraceHold from "MODULES/Lots/Detail/SetTraceHold/SetTraceHold";
import { setTraceHold } from "MODULES/Lots/actions";
import Sync from "MODULES/Lots/Detail/Sync/Sync";
import api from "APP_ROOT/api";
import ToggleQuickbooksSync from "MODULES/Lots/Detail/ToggleQuickbooksSync/ToggleQuickbooksSync";

const exportLotEmail = (uuid, lotLineItemTotalCount) => {
  if (lotLineItemTotalCount > 100) {
    api.lots.export(uuid).then(() => {
      toastr.info("Processing Lot Report. Please check your email.");
    });
  } else {
    window.open(`${API_BASE}/lots/${uuid}/export`, "_blank");
    toastr.success(
      "Processing Lot Report. Please wait for the PDF to generate."
    );
  }
};

const ExportButton = ({ lotLineItemTotalCount }) => {
  const currentUrl = window.location.href;
  const parts = currentUrl.split("/");
  const lotsIndex = parts.findIndex(part => part === "lots");
  const uuid = parts[lotsIndex + 1];

  if (!lotLineItemTotalCount || Number(lotLineItemTotalCount) < 1) {
    return null;
  }

  return (
    <button
      className="btn btn-info"
      onClick={() => exportLotEmail(uuid, lotLineItemTotalCount)}
    >
      Export
    </button>
  );
};

export class Header extends React.Component {
  state = {
    approvePOModalOpen: false,
    receivedLotModalOpen: false,
    importModalOpen: false,
    downloadModalOpen: false,
    cancelLotModalOpen: false,
    cancellationReason: CANCELLATION_REASONS[0].value
  };

  setTraceHold = approveTraceHold => {
    const { setTraceHold: traceHoldSet } = this.props;

    traceHoldSet(approveTraceHold);
  };

  handleSelectChange = e => {
    this.setState({ cancellationReason: e.target.value });
  };

  openCancelLotModal = () => this.setState({ cancelLotModalOpen: true });
  closeCancelLotModal = () => this.setState({ cancelLotModalOpen: false });

  toggle = modalType => () =>
    this.setState({ [modalType]: !this.state[modalType] });

  render() {
    const { lot, received = false, lotLineItemTotalCount } = this.props;
    const {
      approvePOModalOpen,
      cancelLotModalOpen,
      importModalOpen,
      receivedLotModalOpen,
      downloadModalOpen
    } = this.state;
    const cancelled = lot.get(CANCELLED);
    return (
      <div className="page-header page-header-bar">
        <h1>
          <div
            className="btn-group pull-right"
            style={{ display: "flex", alignItems: "center", marginLeft: 20 }}
          >
            <div style={{ marginRight: "10px" }}>
              <ExportButton lotLineItemTotalCount={lotLineItemTotalCount} />
            </div>
            <ActionDropDown
              menuClass="dropdown-menu-right"
              style={{ cursor: "pointer" }}
            >
              <DownloadLot
                open={downloadModalOpen}
                close={this.toggle("downloadModalOpen")}
                lot={lot}
              />
              <MarkLotReceived
                open={receivedLotModalOpen}
                cancelled={lot.get(RECEIVED)}
                close={this.toggle("receivedLotModalOpen")}
              />
              <CancelLot
                open={cancelLotModalOpen}
                cancelled={lot.get(CANCELLED)}
                close={this.closeCancelLotModal}
              />
              <ApproveLot
                open={approvePOModalOpen}
                approved={lot.get(APPROVED)}
                close={this.toggle("approvePOModalOpen")}
              />
              <ImportLineItems
                close={this.toggle("importModalOpen")}
                open={importModalOpen}
              />
              <Authorized roles={[QUALITY_CONTROL]}>
                <SetTraceHold
                  onConfirm={() => this.setTraceHold(true)}
                  lot={lot}
                  traceApproved
                />
                <SetTraceHold
                  onConfirm={() => this.setTraceHold(false)}
                  lot={lot}
                  traceApproved={false}
                />
              </Authorized>
              <Authorized roles={[ACCOUNTING]}>
                <ToggleQuickbooksSync lot={lot} />
                <Sync lot={lot} />
              </Authorized>
              <Forbidden roles={[WAREHOUSE]}>
                <DropDownItem onClick={this.toggle("downloadModalOpen")}>
                  <span>
                    <i className="fa fa-fw fa-print" />{" "}
                    <span>Download Lot PO</span>
                  </span>
                </DropDownItem>
                {!lot.get("importing") && (
                  <DropDownItem onClick={this.toggle("importModalOpen")}>
                    <span>
                      <i className="fa fa-fw fa-download" />{" "}
                      <span>Import Lots</span>
                    </span>
                  </DropDownItem>
                )}
                {!received &&
                  !cancelled && [
                    !lot.get(APPROVED) &&
                      lot.get(CAN_APPROVE) && (
                        <DropDownItem
                          onClick={this.toggle("approvePOModalOpen")}
                        >
                          <span>
                            <i className="fa fa-fw fa-check" />{" "}
                            <span>Approve Lot</span>
                          </span>
                        </DropDownItem>
                      ),
                    <DropDownItem onClick={this.toggle("receivedLotModalOpen")}>
                      <span>
                        <i className="fa fa-fw fa-undo" />{" "}
                        <span>Remove Lot From Inbound</span>
                      </span>
                    </DropDownItem>,
                    !received && (
                      <DropDownItem onClick={this.openCancelLotModal}>
                        <span className="text-danger">
                          <i className="fa fa-fw fa-ban" />{" "}
                          <span>Cancel Lot Order</span>
                        </span>
                      </DropDownItem>
                    )
                  ]}
              </Forbidden>
            </ActionDropDown>
          </div>
          <div className="with-padding">
            <RecordPager baseUrl="/lots" record={lot} />
            <span className="header-content">{lot.get(CODE)}</span>
            <ClipboardCopy name={lot.get(CODE)} type="PO" />
            <span className="small text-muted">
              Created {shortDate(lot.get(CREATED_AT))}
            </span>
            <span className="pull-right">
              <span>Total: {dollars(lot.get(COST))}</span>
            </span>
            <div className="alert-group pull-right">
              {!lot.get(APPROVED) && (
                <Warning icon="pause" label="Requires Approval" />
              )}
              {lot.get(CANCELLED) && <Warning icon="ban" label="Cancelled" />}
            </div>
          </div>
        </h1>
      </div>
    );
  }
}

export default connect(
  state => ({
    id: state.lotDetail.getIn([LOT, ID]),
    lotLineItemTotalCount: state.lots.lineItems.get("totalCount")
  }),
  dispatch => ({
    setTraceHold: val => dispatch(setTraceHold(val))
  })
)(withCurrentUser(Header));

Header.propTypes = {
  currentUser: T.shape({}),
  lot: T.instanceOf(Map),
  received: T.bool,
  lotLineItemTotalCount: T.number,
  setTraceHold: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/Header.jsx